import React from 'react';
import { useNavigate } from 'react-router-dom';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-indigo-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Payment cancelled</h1>
        <p className="text-gray-600 mb-8">
          No worries — your subscription wasn't started. You can subscribe any time to unlock all premium research.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/dashboard')}
            className="stripe-gradient text-white px-8 py-3 rounded-xl font-semibold hover:opacity-90 transition-opacity"
          >
            Back to library
          </button>
          <button
            onClick={() => navigate('/')}
            className="text-gray-500 hover:text-gray-700 py-2 text-sm font-medium transition-colors"
          >
            Go to home page
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
